// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e52dc04f","453":"987a312f","455":"27bc77c7","977":"3b5cfbdb"}[chunkId] + ".chunk.js";
};